import moment from "moment";
import {
  BIDGELY_REPORT_LOADING,
  BIDGELY_CLICK_REPORT_LOADING,
  BIDGELY_DEVICE_REPORT_LOADING,
  BIDGELY_PLATFORM_SUMMARY_REPORT_LOADING,
  SET_BIDGELY_TYPES,
  SET_BIDGELY_SUBTYPES,
  SET_BIDGELY_COUNTS,
  SET_BIDGELY_STATS,
  RESET_BIDGELY_REPORTS,
  ADD_BIDGELY_REPORT_ERROR,
  SET_BIDGELY_CLICK_TABLE,
  SET_BIDGELY_PLATFORMSUMMARY_TABLE,
  SET_BIDGELY_DEVICE,
  BIDGELY_REPORT_DOWNLOADED,
} from "../constants";

// State
import mapColorsToLabels from "../../utils/mapColorsToLabel";
import { RESULT_SESSION_TOKEN } from "../actions/bidgelyActions";

let SAVED_STATE = JSON.parse(sessionStorage.getItem(RESULT_SESSION_TOKEN));
if (SAVED_STATE && moment().isAfter(SAVED_STATE.expires_at)) {
  SAVED_STATE = null;
}

const initial_state = {
  errors: {},
  loading: {
    device: false,
    clicks: false,
    summary: false,
    stats: false,
    counts: false,
    types: false,
    subTypes: false,
    bidgely_download: false,
  },

  // User selected options
  options: {
    startDateTime: moment().subtract(1, "day").startOf("day"), // Default: start of yesterday
    endDateTime: moment().endOf("day"), // Default: through today
    types: "all", // BILL_TO_DATE, DISCONNECT, EBILL, ...
    subTypes: "all", // COMPLETE, NEW, PAYMENT_RECEIVED, ...
    companyCode: "all", // Illinois, Missouri, ...
    expires_at: moment().add(1, "hour").toJSON(),
    ...SAVED_STATE,
  },

  // Options for dropdowns
  types: [], // "BILL_TO_DATE", "DISCONNECT", "EBILL", ...
  subTypes: [], // "COMPLETE", "NEW", "PAYMENT_RECEIVED", ...
  companyCodes: [], // "Illinois", "Missouri", ...

  // Display Data based on selections above
  sent: [
    /* {type_vch: String, subtype_vch: String, count: Number}, ... */
  ],
  totals: {
    /*  received: Number, email: Number,  sms: Number, voice: number, total: number */
  },
  stats: {
    /* email: [{ dispatched: Number, delivered: Number, ...}, sms: [{...}] */
  },
  deviceData: [],
};

export default function (state = initial_state, { type, payload, name }) {
  let { loading, errors } = state;

  switch (type) {
    case BIDGELY_DEVICE_REPORT_LOADING:
    case BIDGELY_CLICK_REPORT_LOADING:
    case BIDGELY_PLATFORM_SUMMARY_REPORT_LOADING:
    case BIDGELY_REPORT_LOADING:
      loading[payload] = true;
      delete errors[payload]; // clear previous errors
      return {
        ...state,
        errors: { ...errors },
        loading: { ...loading },
      };
    case ADD_BIDGELY_REPORT_ERROR:
      // If provided, clear loading
      name && (loading[name] = false);

      if (payload.message) {
        payload = {
          [name]: "There was a problem. Please try again later",
        };
      }

      // Set errors
      errors = {
        ...errors,
        ...payload,
      };
      return {
        ...state,
        errors,
        loading: { ...loading },
      };

    case SET_BIDGELY_TYPES:
      loading["types"] = false;
      delete errors["types"]; // clear previous errors

      return {
        ...state,
        errors: { ...errors },
        loading: { ...loading },
        types: payload || [],
      };

    case SET_BIDGELY_SUBTYPES:
      loading["subTypes"] = false;
      delete errors["subTypes"]; // clear previous errors

      return {
        ...state,
        errors: { ...errors },
        loading: { ...loading },
        subTypes: payload || [],
      };

    case SET_BIDGELY_COUNTS:
      loading["counts"] = false;
      delete errors["counts"]; // clear previous errors

      return {
        ...state,
        errors: { ...errors },
        loading: { ...loading },
        sent: payload.sent || [],
      };

    case SET_BIDGELY_STATS:
      loading["stats"] = false;
      delete errors["stats"]; // clear previous errors

      let totals = {};

      Object.keys(payload).forEach((channel) => {
        mapColorsToLabels(payload[channel].map(({ status }) => status));

        totals[channel] = payload[channel].reduce((total, chstat) => (total += chstat.count), 0);
      });
      // Object.values(payload).forEach((statuses) => {
      //   mapColorsToLabels(statuses.map(({ status }) => status));
      //   totals[statuses] = statuses.reduce((total, chstat) => total += chstat.count);
      // });

      return {
        ...state,
        errors: { ...errors },
        loading: { ...loading },
        stats: payload || {},
        totals,
      };

    case SET_BIDGELY_CLICK_TABLE:
      loading["clicks"] = false;
      delete errors["clicks"]; // clear previous errors
      return {
        ...state,
        loading: { ...loading },
        errors: { ...errors },
        clickTable: payload || {},
      };

    case SET_BIDGELY_PLATFORMSUMMARY_TABLE:
      loading["summary"] = false;
      delete errors["summary"]; // clear previous errors
      return {
        ...state,
        loading: { ...loading },
        errors: { ...errors },
        platformsummaryTable: payload || {},
      };
    case SET_BIDGELY_DEVICE:
      loading["device"] = false;
      delete errors["device"]; // clear previous errors

      return {
        ...state,
        loading: { ...loading },
        errors: { ...errors },
        deviceData: payload || [],
      };

    case BIDGELY_REPORT_DOWNLOADED:
      loading["bidgely_download"] = false;
      delete errors["bidgely_download"]; // clear previous errors

      return state;

    case RESET_BIDGELY_REPORTS:
      return { ...initial_state };

    default:
      return state;
  }
}
